declare const bootstrap: {
    Modal: {
        getOrCreateInstance(element: Element): { show(): void; hide(): void };
    };
};

export function showModal(id: string): void {
    const element = document.getElementById(id);
    if (!element || typeof bootstrap === 'undefined') return;
    bootstrap.Modal.getOrCreateInstance(element).show();
}

export function hideModal(id: string): void {
    const element = document.getElementById(id);
    if (!element || typeof bootstrap === 'undefined') return;
    bootstrap.Modal.getOrCreateInstance(element).hide();
}

export function showAlert(message: string): void {
    const body = document.getElementById('settingsAlertModalBody');
    if (body) {
        body.textContent = message;
    }
    showModal('settingsAlertModal');
}
